module.exports = __webpack_public_path__ + "static/media/fundo_ribeiraopires_armadilhaOvos.8270c68e.png";